<script setup lang="ts">

import CompanyDashboard from "@/components/dashboard/CompanyDashboard.vue";
import SkeletonDashboard from "@/components/dashboard/SkeletonDashboard.vue";
import { useUserStore } from "@/stores/user";

const user = useUserStore()

</script>
<template>
  <CompanyDashboard v-if="user.companyId" />
  <SkeletonDashboard v-else />
</template>
